import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Nav, Button } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import EventBus from "common/EventBus";
import AuthService from "services/auth.service";

import logo from "../../assets/img/logo-wide.svg"; // Adjust the path as necessary

var ps;

function Sidebar(props) {
  const location = useLocation();
  const sidebar = React.useRef();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);

      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, []);

  const logOut = () => {
    AuthService.logout();

    setShowAdminBoard(false);
    setCurrentUser(undefined);
  };

  return (
    <div
      className="sidebar new-back"
      // data-color={props.bgColor}
      data-active-color={props.activeColor}
      // data-color="red"
      data-color="black"
    >
      <div className="logo">
        
        <a href="" target="_blank" className="simple-text logo-normal">
          <img src={logo} className="label-test" alt="Logo"/> 
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes.map((prop, key) => {
            return (
              <li
                className={
                  activeRoute(prop.path) + (prop.logout ? " active-pro" : "")
                }
                key={key}
              >
                <NavLink to={prop.layout + prop.path} className="nav-NavLink">
                <i style={{ fill: "red", width: 24, height: 24 }} className="hc-icon tran-jagg overfill">{React.createElement(prop.icon)}</i>
                   {/* <img src={prop.icon} alt={`${prop.name} icon`} className="icon-image" /> */}
                  <p>{prop.name}</p>
                </NavLink>
              </li>
            );
          })}
          <li className="logout-style">
            <NavLink to={"/"} onClick={logOut}>
              <i className="fa-solid fa-arrow-right-from-bracket log-icon"></i>
              <p className="red-log">Log Out</p>
            </NavLink>
          </li>
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
